import React from "react";
import DayCard from "./DayCard";

/**
 * Sección de una semana del plan.
 * @param {string} label - Etiqueta de la semana.
 * @param {object[]} days - Días de entrenamiento.
 * @param {number} startIndex - Índice global del primer día.
 * @param {number|null} expandedIndex - Índice del día expandido.
 * @param {object} checkedMap - Mapa de días completados.
 * @param {function} onToggle - Callback para expandir/colapsar.
 * @param {function} onCheck - Callback para marcar completado.
 */
export default function WeekSection({
  label,
  days,
  startIndex,
  expandedIndex,
  checkedMap,
  onToggle,
  onCheck,
}) {
  return (
    <div style={{ marginBottom: 28 }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 2.5,
          textTransform: "uppercase",
          color: "#10B981",
          marginBottom: 10,
          paddingLeft: 4,
        }}
      >
        {label}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {days.map((day, i) => {
          const globalIndex = startIndex + i;
          return (
            <DayCard
              key={day.day}
              day={day}
              isExpanded={expandedIndex === globalIndex}
              isChecked={!!checkedMap[globalIndex]}
              onToggle={() => onToggle(globalIndex)}
              onCheck={() => onCheck(globalIndex)}
            />
          );
        })}
      </div>
    </div>
  );
}
